module.exports = __webpack_public_path__ + "img/psih2s-300x240.71af170c.jpg";